// import gl from '../lib/gallery_lib';
export default class FolderManager {
  constructor(el) {
    this.el = el;
    this.closeIcons = this.el.querySelectorAll('.fa-close');
    this.uid = this.el.getAttribute('data-uid');
    this.newsCount = this.el.getAttribute('data-newscount');
    this.items = $(this.el).find('.entry');
    this.pages = $(this.el).data('pages');
    this.amount = this.items.length - 4;
    this.hideSelector = `.entry:gt(-${this.amount})`;
    this.nnLess = $('#nnLessLink');
    this.nnMore = $('#nnMoreLink');
    this.nnMoreStatus = 'up';

    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.closeIcons.forEach(iTag => {
      iTag.addEventListener('click', e => {
        $(e.target)
          .parents('.list-group-item')
          .remove();
        const id = e.target.getAttribute('data-close-id');
        const page = e.target.getAttribute('data-page');
        const Href = `?ignore=${id}&page=${page}`;
        window.location.href = Href;
      });
    });
    this.nnLess.on('click', e => {
      e.preventDefault();
      this.nnMore.removeClass('hidden');
      this.nnMoreStatus = 'up';
      this.nnLess.addClass('hidden');
      // $($hideSelector).slideUp('slow');
      this._slideNNBox('up');
    });
    this.nnMore.on('click', e => {
      e.preventDefault();
      this.nnLess.removeClass('hidden');
      this.nnMore.addClass('hidden');
      this.nnMoreStatus = 'down';
      // $($hideSelector).slideDown('slow');
      this._slideNNBox('down');
    });
  }

  /* eslint-disable class-methods-use-this */
  _slideNNBox(direction) {
    const liObj = $('.entry');
    // const startpoint = Math.floor(liObj.length / 2) - 1;
    const startpoint = 4;
    // Die erste Hälfte ausfiltern
    const secondHalf = liObj.filter(`:gt(${startpoint})`);
    if (direction === 'down') {
      $('#nnMoreLink').fadeOut('slow');
      secondHalf.slideDown('slow', () => {
        $('#nnLessLink, #nnPipe, #nnFwdLink').fadeIn('slow');
      });
    } else {
      $('#nnLessLink, #nnPipe, #nnFwdLink').fadeOut('slow');
      secondHalf.slideUp('slow', () => {
        $('#nnMoreLink').fadeIn('slow');
      });
    }
  }
  /* eslint-disable no-param-reassign */
  /* eslint-enable no-param-reassign */
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/networkbox.js